import { mapMutations, mapGetters, mapActions } from "vuex";
import { itemQuantity } from "../../../api/helpers/shoppingCartHelper.js";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import uuid from "uuid/v1";
import { scrollModify } from "../../../api/helpers/uiHelper";
import { AppConfig } from "../../../../AppConfig";
import { getRecentOrdersOnTable } from "../../../api/services/orderService.js";
import { checkSharedMaxQuantity } from "../../../store/shop/modules/shopping-cart.js";
export default {
  computed: {
    ...mapGetters([
      "cartItems",
      "applicableLoyalityRule",
      "getTotalPoints",
      "getAllStoreMenus",
      "storeSupportsLoyaltyPoints",
      "showNewUi",
      "currencySign",
      "getSharedCartProps",
      "showSharedCart",
      "currentStoreDoc",
      "paylaterSettings",
      "payLaterNotifications",
      "storeSupportEarningLoyaltyPoints"
    ]),
    // modifiers() {
    //   const productId =
    //     (this.showRollIntoProduct
    //       ? this.showRollIntoProduct.ProductID
    //       : null) ||
    //     (this.selectedModifierForCustomize
    //       ? this.selectedModifierForCustomize.LinkedProductID
    //       : null);
    //   return this.findProductAndModifiersByID(
    //     productId || this.category.ProductID
    //   ).modifiers;
    // },
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },
    getPoints() {
      if (this.storeSupportsLoyaltyPoints || this.storeSupportEarningLoyaltyPoints) {
        return this.getTotalPoints;
      } else return null;
    },
    getBasePoints() {
      if (this.storeSupportsLoyaltyPoints || this.storeSupportEarningLoyaltyPoints) {
        return calcLoyaltyPoints(this.applicableLoyalityRule, this.price);
      } else return null;
    },
    getRollIntoPoints() {
      if (this.storeSupportsLoyaltyPoints === true) {
        if (this.selectedRollIntoModiefiers.length == 0)
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.showRollIntoProduct.FixedPriceValue
          );
        else
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.rollIntoPrice
          );
      } else return null;
    },
    totalPrice() {
      let sum = this.priceOverride || this.price || 0;
      var that = this;
      this.ModifierGroupsStates.filter((p) => p.quantity > 0).forEach(
        (state) => {
          var modifier = that.modifiers[state.GroupId].Modifiers.filter(
            (p) => p.ID == state.MID
          )[0];
          sum += (this.computePrice(modifier) || 0) * state.quantity;
        }
      );
      const upsellSum = this.upsellProducts.reduce((acc, value) => {
        return acc + value.Price;
      }, 0);
      return (
        sum * this.quantity +
        this.rollIntoPrice +
        (this.forceUpdate ? 0 : 0) +
        upsellSum
      );
    },
    cartQuantity() {
      var item = { id: this.productId };
      const iq = itemQuantity(item, this.selectedModifiers, this.cartItems);
      return iq + this.quantity;
    },

    maxQuantity() {
      var item = { id: this.category.ProductID || this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return this.maxItemQuantity - iq;
    },
    createModifierObj(modifier) {
      return { md: modifier, count: 1 };
    },
    isDisabledAddCards() {
      return this.cartQuantity > this.maxItemQuantity || this.toggleRollInto;
    },
    rollIntoParams() {
      if (this.selectedModifierForCustomize) {
        return {
          product:
            this.menuCopy.Products[
              this.selectedModifierForCustomize.LinkedProductID
            ],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.selectedModifierForCustomize.LinkedProductID,
          initModifiers: this.selectedModifierForCustomize.selectedSubmodifiers,
          selectedModifier: this.selectedModifierForCustomize,
        };
      } else if (this.showRollIntoProduct) {
        return {
          product: this.menuCopy.Products[this.showRollIntoProduct.ProductID],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.showRollIntoProduct.ProductID,
          initModifiers: this.selectedRollIntoModiefiers,
        };
      } else {
        return {};
      }
    },

    productImageExistsNewUi() {
      return !!this.getProductImage(this.product);
    },
  },
  methods: {
    ...mapMutations(["Add_ProductItem", "confirmRollIntos"]),
    ...mapActions(["applyPriceTriggers", "toggleAddToCartOpen"]),
    onUpsellValue(value) {
      this.upsellProducts = value || [];
    },
    fixQuantity(group, checked, md, groupID) {
      if (md && group) {
        if (checked) {
          if (group.IsSingleSel) {
            group.Modifiers.forEach(function (item) {
              item.quantity = 0;
              item.IsSelected = false;
            });
            this.ModifierGroupsStates.filter(
              (p) => p.GroupId == groupID
            ).forEach((state) => {
              state.quantity = 0;
              state.IsSelected = false;
            });
          }
          if (!md.quantity || md.quantity == 0) {
            md.quantity = 1;
            md.IsSelected = true;
          }
        } else {
          md.quantity = 0;
          md.IsSelected = false;
        }
        var state = this.ModifierGroupsStates.filter(
          (p) => p.GroupId == groupID && p.MID == md.ID
        )[0];
        if (state) {
          state.quantity = md.quantity;
          state.IsSelected = md.IsSelected;
        } else {
          state = {
            GroupId: groupID,
            MID: md.ID,
            quantity: md.quantity,
            IsSelected: md.IsSelected,
          };
          this.ModifierGroupsStates.push(state);
        }
      }
      this.$forceUpdate();
    },
    findProductAndModifiersByID(productId) {
      const allMenus = [...this.getAllStoreMenus];
      for (let i = 0; i < allMenus.length; i++) {
        const menu = allMenus[i];
        if (
          typeof menu.Products == "object" &&
          typeof menu.Products[productId] != "undefined"
        ) {
          return {
            product: menu.Products[productId],
            modifiers: menu.ModifierGroups,
          };
        }
      }
    },
    closeModal() {
      this.$parent.closeModal();
    },
    closeModalMobile() {
      this.$nextTick(() => {
        this.$parent.closeModal();
        scrollModify(false);
      });
    },

    inc() {
      this.quantity++;
    },
    dec() {
      this.quantity--;
    },
    getModifiers() {
      const selectedModifiers = [];
      // sort modifier list for printing modifiers in correct order.
      const sortedList = this.ModifierGroupsStates.sort((a, b) => {
        if (!a.GroupDisplayOrder && a.GroupDisplayOrder !== 0) {
          a.GroupDisplayOrder = 1000;
        }
        if (!b.GroupDisplayOrder && b.GroupDisplayOrder !== 0) {
          b.GroupDisplayOrder = 1000;
        }
        let result = a.GroupDisplayOrder - b.GroupDisplayOrder;
        if (!result) {
          result = a.ModifierDisplayOrder - b.ModifierDisplayOrder;
        }
        return result;
      });

      sortedList
        .filter((p) => p.quantity > 0)
        .forEach((state) => {
          const that = this;
          selectedModifiers.push({
            ...that.modifiers[state.GroupId].Modifiers.find(
              (p) => p.ID == state.MID
            ),
            quantity: state.quantity,
          });
        });
      return selectedModifiers;
    },
    getModifierValidation(showError = true) {
      var validate = true;
      if (this.$refs.modifiersRefs) {
        validate = this.$refs.modifiersRefs.validate(showError);
      }
      return validate;
    },
    addToCart() {
      if (this.getModifierValidation()) {
        const rollIntoPayload = {
          id: this.showRollIntoProduct ? this.showRollIntoProduct.ID : null,
          modifiers: this.selectedRollIntoModiefiers,
        };
        const item = {
          id: this.category.ProductID,
          uniqueId: uuid(),
          itemNote: this.itemNote,
          code: this.product.ProductCode,
          name: this.category.Name,
          description: this.product.ShortDescription,
          photoUrl: this.product.PhotoUrl,
          tax: this.product.TaxRate,
          RewardPoint: this.product.RewardPoint,
          price: this.price,
          categoryId: this.parentCategory.ID,
          categoryName: this.parentCategory.Name,
          rollIntoPayload,
          IsMaxQuantityLevelEnabled: this.product.IsMaxQuantityLevelEnabled,
        };
        const exceedMaxQuantity = checkSharedMaxQuantity(item, this.quantity);
        if (exceedMaxQuantity) {
          alert(
            `The quantity you selected for this item exceeds the limit of ${this.paylaterSettings.MaximumQuantityLimit}.Please adjust the quantity accordingly to proceed with your order`
          );
          return;
        }
        this.Add_ProductItem({
          item: item,
          quantity: this.quantity,
          PreparationTime: this.product.PreparationTime,
          ProductCategoryIDs: this.product.ProductCategoryIDs,
          ProductTagIDs: this.product.ProductTagIDs,
          modifiers: this.getModifiers(),
          sharedcart: this.showSharedCart,
          user: this.getSharedCartProps.user,
          table: this.getSharedCartProps.table,
          storeId: this.currentStoreDoc.ID,
        });
        this.addUpsellsToCart();
        this.applyPriceTriggers();
        this.confirmRollInto(rollIntoPayload);
        this.applyPriceTriggers();
      } else {
        this.$refs.modifiersRefs.showValidation();
      }
    },
    addToCartMobile() {
      if (this.getModifierValidation()) {
        const rollIntoPayload = {
          id: this.showRollIntoProduct ? this.showRollIntoProduct.ID : null,
          modifiers: this.selectedRollIntoModiefiers,
        };
        const item = {
          id: this.category.ProductID,
          uniqueId: uuid(),
          itemNote: this.itemNote,
          code: this.product.ProductCode,
          name: this.category.Name,
          description: this.product.ShortDescription,
          photoUrl: this.product.PhotoUrl,
          tax: this.product.TaxRate,
          RewardPoint: this.product.RewardPoint,
          price: this.price,
          categoryId: this.parentCategory.ID,
          categoryName: this.parentCategory.Name,
          rollIntoPayload,
          IsMaxQuantityLevelEnabled: this.product.IsMaxQuantityLevelEnabled,
        };
        const exceedMaxQuantity = checkSharedMaxQuantity(item, this.quantity);
        if (exceedMaxQuantity) {
          alert(
            `The quantity you selected for this item exceeds the limit of ${this.paylaterSettings.MaximumQuantityLimit}.Please adjust the quantity accordingly to proceed with your order`
          );
          return;
        }
        this.Add_ProductItem({
          item: item,
          quantity: this.quantity,
          PreparationTime: this.product.PreparationTime,
          ProductCategoryIDs: this.product.ProductCategoryIDs,
          ProductTagIDs: this.product.ProductTagIDs,
          modifiers: this.getModifiers(),
          sharedcart: this.showSharedCart,
          user: this.getSharedCartProps.user,
          table: this.getSharedCartProps.table,
          storeId: this.currentStoreDoc.ID,
        });
        this.addUpsellsToCart();
        this.$nextTick(() => {
          this.$parent.closeModal();
          scrollModify(false);
        });
        this.applyPriceTriggers();
        this.confirmRollInto(rollIntoPayload);
        this.applyPriceTriggers();
      } else {
        this.$refs.modifiersRefs.showValidation();
      }
    },
    addUpsellsToCart() {
      this.upsellProducts.forEach((up) => {
        this.Add_ProductItem({
          item: {
            id: up.ProductID,
            uniqueId: uuid(),
            code: up.ProductCode,
            name: up.Name,
            tax: up.TaxRate,
            RewardPoint: up.RewardPoint,
            price: up.Price,
          },
          quantity: 1,
          PreparationTime: up.PreparationTime,
          ProductCategoryIDs: up.ProductCategoryIDs,
          ProductTagIDs: up.ProductTagIDs,
          modifiers: [],
          sharedcart: this.showSharedCart,
          user: this.getSharedCartProps.user,
          table: this.getSharedCartProps.table,
          storeId: this.currentStoreDoc.ID,
          IsMaxQuantityLevelEnabled: up.IsMaxQuantityLevelEnabled,
        });
      });
    },
    imgHttpError() {
      if (this.$refs.headerImg && this.$refs.headerImg.style)
        this.$refs.headerImg.style.display = "none";
    },
    selectRollIntoModiefiers(modifiers) {
      if (this.selectedModifierForCustomize) {
        this.$set(
          this.selectedModifierForCustomize,
          "selectedSubmodifiers",
          modifiers
        );
        // this.selectedModifierForCustomize.selectedSubmodifiers = modifiers;
        this.selectedModifierForCustomize = null;
      } else this.selectedRollIntoModiefiers = modifiers;
      this.toggleRollInto = false;
    },
    getImageStyle() {
      var styles = this.imageStyles;
      if (!this.isRolldStore()) {
        if (this.viewConfig.ImageCenterMode) {
          styles.push({
            "background-image": `url("${this.getProductImage(this.product)}")`,
            "background-size": "contain",
            "background-repeat": "no-repeat",
            "background-position": "center",
            "background-position-x": "center",
          });
        } else {
          styles.push({
            "background-image": `url("${this.getProductImage(this.product)}")`,
            "border-bottom-left-radius": "5px",
            "border-bottom-right-radius": "5px",
          });
        }

        return styles;
      } else {
        styles.push({
          "background-image": `url("${this.getProductImage(this.product)}")`,
          "background-size": "142% auto",
          "background-repeat": "no-repeat",
          "background-position": this.isMobile() ? "0px -300px" : "0px -341px",
          zoom: !this.isMobile() && !this.isShowSecondCol ? 1.1 : 1,
        });
        return styles;
      }
    },
    getProductImage(product) {
      if (!this.isRolldStore()) {
        if (product.PhotoUrl) return product.PhotoUrl;
        else return null;
      } else {
        return `https://firebasestorage.googleapis.com/v0/b/${AppConfig.firebaseProjectId}.appspot.com/o/Photos%2F${product.ProductCode}.jpg?alt=media&token=adc34ed7-644d-45b0-a617-1f88e8024243`;
      }
    },
    customizeSubmodifier(modifier) {
      this.selectedModifierForCustomize = modifier;
      this.toggleRollInto = true;
      if (this.isIos)
        this.$nextTick(() => {
          scrollModify(true, true);
        });
    },
    computePrice(modifier) {
      var sum = modifier.Price;
      if (modifier.selectedSubmodifiers) {
        modifier.selectedSubmodifiers.forEach((element) => {
          sum += element.Price * element.quantity;
        });
      }
      return sum;
    },
    rollIntoButtonClassNames(selectedRollIntoModiefiers) {
      const styles = this.mobileStyles ? this.mobileStyles : this.desktopStyles;
      return selectedRollIntoModiefiers && selectedRollIntoModiefiers.length > 0
        ? styles.rollIntoModifyButton
        : styles.roolIntoButton;
    },
    async checkSharedCartDuplicateItems() {
      if (this.paylaterSettings.Enabled) {
        const table = sessionStorage.getItem("table");

        if (table && this.payLaterNotifications.DuplicateItemsAlert.Enabled) {
          const orders = await getRecentOrdersOnTable(
            this.currentStoreDoc.ID,
            table,
            10
          );
          const duplicate = orders.some((order) =>
            order.OrderItems.some(
              (item) => item.Product_ID.toString() == this.productId.toString()
            )
          );
          if (duplicate) {
            this.showDuplicateItemsAlert = true;
          }
        }
      }
    },
  },
};
